import React, { useState, useEffect } from "react";
import UserService from "../services/user.service";
import { Alert, Table, Button, Container, Modal, Form, Pagination, Spinner } from 'react-bootstrap';
import 'react-datepicker/dist/react-datepicker.css';
import { rentManagerColumns } from '../config/tableColumns'; // Import der Spaltenkonfiguration

const BatchManagerSubVo = () => {
  const [batches, setBatches] = useState([]);
  const [ads, setAds] = useState([]);
  
  const [loading, setLoading] = useState(false);
  const [apiErrors, setApiErrors] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [searchTerm, setSearchTerm] = useState('');
  const [sortField, setSortField] = useState('batch_name');
  const [sortOrder, setSortOrder] = useState('asc');
  // NEU: Speicher für die Tarife des Wiederverkäufers
  const [subVoTariffs, setSubVoTariffs] = useState([]);
  const [loadingTariffs, setLoadingTariffs] = useState(false);

  // State für das "Kommissionieren"-Modal
  const [showRentModal, setShowRentModal] = useState(false);
  const [rentFormData, setRentFormData] = useState({});
  const [errors, setErrors] = useState({});


  useEffect(() => {
    loadBatches();
    loadAds();
    loadSubVoTariffs(); // HINZUGEFÜGT: Lädt die Tarife beim Start
  }, [currentPage, searchTerm, sortField, sortOrder]);

  const loadBatches = async () => {
    setLoading(true);
    try {
      // KORREKTUR: Aufruf der neuen, korrekten Service-Funktion
      const response = await UserService.getBatchesForSubVoBoard({ // <- DIESE ZEILE ÄNDERT SICH
        page: currentPage,
        search: searchTerm,
        sort: sortField,
        order: sortOrder
      });
      setBatches(response.data.batches);
      setTotalPages(response.data.totalPages);
    } catch (error) {
      setBatches([]); 
      setApiErrors('Fehler beim Laden der Batches: ' + error.message);
    } finally {
      setLoading(false);
    }
  };

  const loadAds = async () => {
    try {
      const response = await UserService.getAllAds({ page: 1, search: '', sort: '', order: 'asc' });
      setAds(response.data.ads);
    } catch (error) {
      setApiErrors('Fehler beim Laden der Ads: ' + error.message);
    }
  };

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
    setCurrentPage(1); // Bei Suche auf die erste Seite zurücksetzen
  };

  const handleSortChange = (field) => {
    const newSortOrder = sortField === field && sortOrder === 'asc' ? 'desc' : 'asc';
    setSortField(field);
    setSortOrder(newSortOrder);
  };

  // NEU: Diese Funktion holt die Tarife, die nur dem eingeloggten Wiederverkäufer gehören.
  const loadSubVoTariffs = async () => {
    setLoadingTariffs(true); // Wir signalisieren, dass das Laden beginnt.
    try {
      // Wir rufen den UserService auf, der mit unserem Server spricht.
      // Die Funktion getTariffBoard ist dafür gedacht, die Tarife des aktuell eingeloggten Benutzers zu holen.
      const response = await UserService.getTariffBoard(); 
      setSubVoTariffs(response.data.tariffs); // Wir speichern die erhaltene Tarifliste im Speicher (State).
    } catch (error) {
      // Falls ein Fehler auftritt, zeigen wir eine Fehlermeldung an.
      setApiErrors('Fehler beim Laden der Tarife: ' + error.message);
    } finally {
      // Egal was passiert, am Ende signalisieren wir, dass das Laden beendet ist.
      setLoadingTariffs(false);
    }
  };

  // --- Logik für das "Kommissionieren"-Modal ---
  const handleRentClick = (batch) => {
    setRentFormData({
      batch_id: batch.batch_id,
      requested_quantity: '',
      user_id: '', // ADM-ID
      order_type: 'RENT',
    });
    setErrors({});
    setShowRentModal(true);
  };
  
  const handleRentChange = (e) => {
    const { name, value } = e.target;
    setRentFormData({ ...rentFormData, [name]: value });
  };
  
  const handleRentSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await UserService.rentBatchPortion(rentFormData);
      setShowRentModal(false);
      loadBatches(); // Batches neu laden, um die vermietete Menge zu aktualisieren
    } catch (error) {
      setApiErrors('Fehler beim Kommissionieren des Batches: ' + error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container style={{ paddingTop: '20px' }}>
      <h1 style={{ color: '#333', marginBottom: '30px' }}>Kommissionswarenmanager</h1>
      {apiErrors && <Alert variant="danger">{apiErrors}</Alert>}
      
      {/* KORREKTUR: Suchfeld wieder hinzugefügt */}
      <div style={{ display: 'flex', gap: '15px', marginBottom: '20px', flexWrap: 'wrap' }}>
        <Form.Control
          type="text"
          placeholder="Nach Chargenname suchen"
          value={searchTerm}
          onChange={handleSearchChange}
          style={{ maxWidth: '300px' }}
        />
      </div>
      
      {loading && (
        <div style={{ textAlign: 'center', padding: '40px' }}>
          <Spinner animation="border" />
          <p style={{ marginTop: '10px' }}>Lade, bitte warten...</p>
        </div>
      )}
      
      <Table striped bordered hover responsive>
        <thead>
          <tr>
            {rentManagerColumns.map(col => (
              <th key={col.key} onClick={() => col.sortable && handleSortChange(col.key)} style={{ cursor: col.sortable ? 'pointer' : 'default' }}>
                {col.header}
              </th>
            ))}
            {/* KORREKTUR: Statische Spaltenüberschrift für Aktionen */}
            <th>Aktionen</th>
          </tr>
        </thead>
        <tbody>
          {batches.map(batch => {
            const isFullyRented = batch.batch_quantity === batch.rented_quantity;
            return (
              <tr key={batch.batch_id} style={{ backgroundColor: isFullyRented ? '#fff0f1' : '' }}>
                {rentManagerColumns.map(col => (
                  <td key={col.key}>
                    {/* Die Render-Logik aus der Konfigurationsdatei wird hier verwendet */}
                    {col.render ? col.render(batch) : (batch[col.key] || 'N/A')}
                  </td>
                ))}
                {/* KORREKTUR: Aktions-Button wieder hinzugefügt */}
                <td>
                  <Button 
                    variant="primary" 
                    size="sm"
                    disabled={isFullyRented}
                    onClick={() => handleRentClick(batch)}
                  >
                    Kommissionieren
                  </Button>
                </td>
              </tr>
            );
          })}
        </tbody>
      </Table>
      
      {/* KORREKTUR: Pagination wieder hinzugefügt */}
      <Pagination style={{ marginTop: '20px', justifyContent: 'center' }}>
        {[...Array(totalPages)].map((_, index) => (
          <Pagination.Item 
            key={index + 1} 
            active={index + 1 === currentPage} 
            onClick={() => setCurrentPage(index + 1)}
          >
            {index + 1}
          </Pagination.Item>
        ))}
      </Pagination>

      {/* Modal zum Kommissionieren von Chargen */}
      <Modal show={showRentModal} onHide={() => setShowRentModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Charge Kommissionieren</Modal.Title>
        </Modal.Header>
        
        
        
        
        <Modal.Body>
          <Form onSubmit={handleRentSubmit}>
                  <Form.Group controlId="requested_quantity">
                    <Form.Label>Anzahl</Form.Label>
                    <Form.Control
                      type="number"
                      name="requested_quantity"
                      value={rentFormData.requested_quantity}
                      onChange={handleRentChange}
                      required
                    />
                  </Form.Group>

                  <Form.Group controlId="user_id" style={{ marginTop: '15px' }}>
                    <Form.Label>Käufer (ADM) auswählen</Form.Label>
                    <Form.Control
                      as="select"
                      name="user_id"
                      value={rentFormData.user_id}
                      onChange={handleRentChange}
                      required
                    >
                      <option value="">Bitte Käufer auswählen</option>
                      {ads.map(ad => (
                        <option key={ad.adm_id} value={ad.adm_id}>
                          {ad.company_name} (ID: {ad.adm_id})
                        </option>
                      ))}
                    </Form.Control>
                  </Form.Group>
                  
                  {/* === NEUES FELD FÜR TARIF-AUSWAHL === */}
                  <Form.Group controlId="tariff_id" style={{ marginTop: '15px' }}>
                    <Form.Label>Tarif für die Verrechnung auswählen</Form.Label>
                    <Form.Control
                      as="select"
                      name="tariff_id" 
                      value={rentFormData.tariff_id}
                      onChange={handleRentChange}
                      required
                    >
                      <option value="">Bitte Tarif auswählen</option>
                      {subVoTariffs.map(tariff => (
                        <option key={tariff.tariff_id} value={tariff.tariff_id}>
                          {tariff.tariff_name} ({tariff.amount_eur_net}€)
                        </option>
                      ))}
                    </Form.Control>
                  </Form.Group>
                  {/* === ENDE NEUES FELD === */}

                  <Button type="submit" style={{ marginTop: '20px' }} disabled={loading}>
                    {loading ? 'Wird gemietet...' : 'Jetzt mieten'}
                  </Button>
                </Form>





        </Modal.Body>
      </Modal>

    </Container>
  );
};

export default BatchManagerSubVo;